import { Component, OnInit } from '@angular/core';
declare var CodeMirror: any;

@Component({
    selector: 'app-editor',
    templateUrl: './editor.component.html',
    styleUrls: ['./editor.component.scss']
})
export class EditorComponent implements OnInit {
    ngOnInit(){}
    showPractice: boolean = true;
    showRejectAccept: boolean = false;
    showPracticeComponent() {
        console.log("showPracticeComponent");
        this.showPractice = false;
    }
    hidePracticeComponent(){
        this.showPractice = true;

    }
    showRejectAcceptDiv(){
        this.showRejectAccept = true;

    }
}
